import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AuthorityClaimsSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type AuthorityClaimsSubscription = { __typename?: 'subscription_root', authority_claims: Array<{ __typename?: 'authority_claims', id: any, email: string, first_name: string, last_name: string, jurisdiction_id?: any | null, new_jurisdiction_name?: string | null, new_jurisdiction_ahj_type?: string | null, new_jurisdiction_city?: string | null, new_jurisdiction_county?: string | null, new_jurisdiction_state?: string | null, match_source: string, status: string, email_verified_at?: any | null, reviewed_at?: any | null, completed_at?: any | null, created_at: any, jurisdiction?: { __typename?: 'jurisdictions', id: any, name: string, city?: string | null, county?: string | null, state: string, setup_completed: boolean } | null }> };


export const AuthorityClaimsDocument = gql`
    subscription AuthorityClaims {
  authority_claims(order_by: {created_at: desc}) {
    id
    email
    first_name
    last_name
    jurisdiction_id
    new_jurisdiction_name
    new_jurisdiction_ahj_type
    new_jurisdiction_city
    new_jurisdiction_county
    new_jurisdiction_state
    match_source
    status
    email_verified_at
    reviewed_at
    completed_at
    created_at
    jurisdiction {
      id
      name
      city
      county
      state
      setup_completed
    }
  }
}
    `;

/**
 * __useAuthorityClaimsSubscription__
 *
 * To run a query within a React component, call `useAuthorityClaimsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAuthorityClaimsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorityClaimsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useAuthorityClaimsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<AuthorityClaimsSubscription, AuthorityClaimsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AuthorityClaimsSubscription, AuthorityClaimsSubscriptionVariables>(AuthorityClaimsDocument, options);
      }
export type AuthorityClaimsSubscriptionHookResult = ReturnType<typeof useAuthorityClaimsSubscription>;
export type AuthorityClaimsSubscriptionResult = Apollo.SubscriptionResult<AuthorityClaimsSubscription>;